import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    trixId: String
  }

  connect() {
    this.trix = document.getElementById(this.trixIdValue)
  }

  insert(event) {
    this.trix.editor.insertString(event.currentTarget.getAttribute('title'))
  }
}
